import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react'
import React from 'react'
import { AiFillGithub, AiFillLinkedin, AiOutlineArrowUp } from "react-icons/ai";
import { BiLinkExternal } from "react-icons/bi"

const CardDiv = ({ e }) => {
    return (
        <Flex boxShadow={'0 0 10px rgb(2,190,150)'} p={'0px 20px 20px 20px'} alignItems={'center'} justifyContent={'center'} direction={'column'} border={'none'} borderRadius={'20px'} overflow={'hidden'}
        className='project-card'>
            <Heading color={'rgb(2,190,150)'} p={'10px 0'}
            className='project-title'>{e.title}</Heading>
            <Image src={e.img} alt='project' textAlign={'center'} borderRadius={'10px'}  width={'100%'}
            className='project-image'/>
            <Flex color={'white'} fontWeight={'bold'} justifyContent={'space-evenly'} width={'100%'}
            className='project-techstack'>{
                 e.techstack.map((ele,ind)=>{
                    return <Text>{ele}</Text>
                 }) 
                }</Flex>
            <Text color={'white'} className='project-description'>{e.disc}</Text>
            <Flex color={'rgb(2,190,150)'} justifyContent={'space-around'} gap={'80px'} >
                <a href={e.deployed} target='_blank' 
               
                 className='project-deployed-link'><BiLinkExternal style={{ fontSize: '30px' }}  /></a>
                <a href={e.github} target='_blank'
                 style={{ fontSize: 'large' }} className='project-github-link'><AiFillGithub style={{ fontSize: '30px' }} /></a>
            </Flex>
        </Flex>
    )
}

export default CardDiv